import {sprintf} from 'sprintf-js';
import locales from '../locales/locales';
export default [
    {
        'name':'Free',
        'monthlyPriceId':null,
        'pricePerMonth':0,
        'icon':'faHeart',
        'needsAccount':false,
        'features':[
            {
                'name':Object.fromEntries(
                    Object.entries(locales.pricingXCreditsPerMonth).map(([k,v])=>[k,sprintf(v,20)])
                ),
                'has':true,
            },
            {
                'name':locales.navBrowserExtension,
                'has':true,
            },
            {
                'name':locales.pricingAutoSelectedLLM,
                'has':true,
            },
            {
                'name':'DeepSeek-V4 Flash',
                'has':false,
            },
            {
                'name':'GPT-5.4 nano',
                'has':false,
            },
            {
                'name':'Claude Sonnet 5',
                'has':false,
            },
            {
                'name':'GPT-5.6 Terra',
                'has':false,
            },
            {
                'name':locales.pricingNoWatermark,
                'has':false,
            },
        ],
    },
    {
        'name':'Lite',
        'monthlyPriceId':'pri_01k4db66j6n27x9fs7mxkdp51f',
        'pricePerMonth':5.99,
        'icon':'faFeather',
        'needsAccount':true,
        'features':[
            {
                'name':Object.fromEntries(
                    Object.entries(locales.pricingXCreditsPerMonth).map(([k,v])=>[k,sprintf(v,1000)])
                ),
                'has':true,
            },
            {
                'name':locales.navBrowserExtension,
                'has':true,
            },
            {
                'name':locales.pricingAutoSelectedLLM,
                'has':true,
            },
            {
                'name':'DeepSeek-V4 Flash',
                'has':true,
            },
            {
                'name':'GPT-5.4 nano',
                'has':true,
            },
            {
                'name':'Claude Sonnet 5',
                'has':false,
            },
            {
                'name':'GPT-5.6 Terra',
                'has':false,
            },
            {
                'name':locales.pricingNoWatermark,
                'has':false,
            },
        ],
    },
    {
        'name':'Standard',
        'monthlyPriceId':'pri_01k4db6vtgbzamsksc9y7k8zvf',
        'pricePerMonth':9.99,
        'icon':'faGem',
        'needsAccount':true,
        'features':[
            {
                'name':Object.fromEntries(
                    Object.entries(locales.pricingXCreditsPerMonth).map(([k,v])=>[k,sprintf(v,3000)])
                ),
                'has':true,
            },
            {
                'name':locales.navBrowserExtension,
                'has':true,
            },
            {
                'name':locales.pricingAutoSelectedLLM,
                'has':true,
            },
            {
                'name':'DeepSeek-V4 Flash',
                'has':true,
            },
            {
                'name':'GPT-5.4 nano',
                'has':true,
            },
            {
                'name':'Claude Sonnet 5',
                'has':true,
            },
            {
                'name':'GPT-5.6 Terra',
                'has':false,
            },
            {
                'name':locales.pricingNoWatermark,
                'has':true,
            },
        ],
    },
    {
        'name':'Ultimate',
        'monthlyPriceId':'pri_01k4db7jm756hg56vsehw5t1dh',
        'pricePerMonth':24.99,
        'icon':'faCrown',
        'needsAccount':true,
        'features':[
            {
                'name':Object.fromEntries(
                    Object.entries(locales.pricingXCreditsPerMonth).map(([k,v])=>[k,sprintf(v,6000)])
                ),
                'has':true,
            },
            {
                'name':locales.pricingAutoSelectedLLM,
                'has':true,
            },
            {
                'name':locales.navBrowserExtension,
                'has':true,
            },
            {
                'name':'DeepSeek-V4 Flash',
                'has':true,
            },
            {
                'name':'GPT-5.4 nano',
                'has':true,
            },
            {
                'name':'Claude Sonnet 5',
                'has':true,
            },
            {
                'name':'GPT-5.6 Terra',
                'has':true,
            },
            {
                'name':locales.pricingNoWatermark,
                'has':true,
            },
        ],
    },
];

